/* ColdGear chapter interactions — delegated so theme-editor reloads keep working */
(function () {
  if (window.__cgChapter) return;
  window.__cgChapter = true;

  var fine = window.matchMedia('(hover: hover) and (pointer: fine)');

  function activate(group, key) {
    group.querySelectorAll('[data-cg-key]').forEach(function (el) {
      el.classList.toggle('is-on', el.getAttribute('data-cg-key') === key);
    });
  }

  function onPoint(e) {
    var item = e.target.closest && e.target.closest('[data-cg-key]');
    if (!item) return;
    var group = item.closest('[data-cg-group]');
    if (group && group.getAttribute('data-cg-group') !== 'tabs') activate(group, item.getAttribute('data-cg-key'));
  }
  document.addEventListener('pointerover', function (e) { if (fine.matches) onPoint(e); });
  /* tabs switch on click (not hover) */
  document.addEventListener('click', function (e) {
    var tab = e.target.closest('[data-cg-group="tabs"] [data-cg-key]');
    if (!tab) return;
    var key = tab.getAttribute('data-cg-key');
    var root = tab.closest('.cg-ch');
    activate(tab.closest('[data-cg-group]'), key);
    root.querySelectorAll('[data-cg-panel]').forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-cg-panel') === key); });
  });
  document.addEventListener('focusin', onPoint);

  /* scene: leaving the board clears highlights */
  document.addEventListener('pointerout', function (e) {
    var board = e.target.closest && e.target.closest('[data-cg-group="scene"]');
    if (board && !board.contains(e.relatedTarget)) {
      board.querySelectorAll('.is-on').forEach(function (el) { el.classList.remove('is-on'); });
    }
  });

  /* before / after */
  document.addEventListener('input', function (e) {
    if (!e.target.matches('.cg-compare__range')) return;
    e.target.closest('.cg-compare__frame').style.setProperty('--pos', e.target.value + '%');
  });

  /* reveal on scroll */
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (entries) {
    entries.forEach(function (en) {
      if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); }
    });
  }, { rootMargin: '0px 0px -12% 0px' }) : null;

  function scan(root) {
    (root || document).querySelectorAll('.cg-reveal:not(.is-in), [data-cg-watch]:not(.is-in)').forEach(function (el) {
      if (io) io.observe(el); else el.classList.add('is-in');
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { scan(); });
  else scan();
  /* safety net: anything already inside the viewport is shown even if the observer is slow (old Safari, hidden tabs) */
  function sweep() {
    var vh = window.innerHeight;
    document.querySelectorAll('.cg-reveal:not(.is-in), [data-cg-watch]:not(.is-in)').forEach(function (el) {
      var r = el.getBoundingClientRect(); if (r.top < vh * 0.98 && r.bottom > 0) el.classList.add('is-in');
    });
  }
  window.addEventListener('load', function () { setTimeout(sweep, 400); setTimeout(sweep, 1500); });
  var sweepT; window.addEventListener('scroll', function () { clearTimeout(sweepT); sweepT = setTimeout(sweep, 180); }, { passive: true });
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); deck(); });

  /* mobile deck: a chapter taller than the screen pins only once its bottom reaches the bottom edge */
  var mobile = window.matchMedia('(max-width: 989px)');
  function deck() {
    var vh = window.innerHeight;
    document.querySelectorAll('main .shopify-section.cg-section:not(.cg-section--static)').forEach(function (s) {
      if (!mobile.matches) { s.style.removeProperty('--cg-deck-top'); return; }
      s.style.setProperty('--cg-deck-top', Math.min(0, vh - s.offsetHeight) + 'px');
    });
  }
  var queued = false;
  function queueDeck() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; deck(); }); }
  if ('ResizeObserver' in window) {
    var ro = new ResizeObserver(queueDeck);
    var watch = function () { document.querySelectorAll('main .shopify-section.cg-section:not(.cg-section--static)').forEach(function (s) { ro.observe(s); }); };
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', watch); else watch();
    document.addEventListener('shopify:section:load', watch);
  }
  window.addEventListener('resize', queueDeck);
  window.addEventListener('load', queueDeck);
  if (mobile.addEventListener) mobile.addEventListener('change', queueDeck);
  queueDeck();
  /* collection filters: sheet open/close + sort autosubmit */
  function sheetFor(el) { var f = el.closest('[data-cg-filters]'); return f && f.querySelector('[data-cg-sheet]'); }
  function setSheet(sheet, open) {
    if (!sheet) return;
    sheet.hidden = !open;
    var btn = sheet.closest('[data-cg-filters]').querySelector('[data-cg-sheet-open]');
    if (btn) btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    document.documentElement.classList.toggle('cg-lock', open && mobile.matches);
  }
  document.addEventListener('click', function (e) {
    var o = e.target.closest('[data-cg-sheet-open]');
    if (o) { var sh = sheetFor(o); setSheet(sh, sh.hidden); return; }
    var c = e.target.closest('[data-cg-sheet-close]');
    if (c) setSheet(c.closest('[data-cg-sheet]'), false);
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') document.querySelectorAll('[data-cg-sheet]:not([hidden])').forEach(function (s) { setSheet(s, false); });
  });
  document.addEventListener('change', function (e) {
    if (e.target.matches('[data-cg-autosubmit]')) e.target.form.submit();
  });
  /* drop empty price inputs so the URL stays clean */
  document.addEventListener('submit', function (e) {
    if (!e.target.matches('[data-cg-filters]')) return;
    e.target.querySelectorAll('input[type=number]').forEach(function (i) { if (i.value === '') i.disabled = true; });
  });

  /* league panels: keep the figure's face in frame as the box changes shape */
  function focusImg(bg) {
    var img = bg.querySelector('img');
    if (!img || !img.naturalWidth) return;
    var f = (bg.getAttribute('data-cg-focus') || '0.5,0.2').split(',').map(Number);
    var w = bg.clientWidth, h = bg.clientHeight, nw = img.naturalWidth, nh = img.naturalHeight;
    if (!w || !h) return;
    var s = Math.max(w / nw, h / nh), W = nw * s, H = nh * s;
    var open = bg.closest('.cg-panel.is-on') && w > h;
    var ty = open ? 0.34 : 0.4;            /* where the face should sit in the box */
    var X = W > w ? Math.min(1, Math.max(0, (f[0] * W - 0.5 * w) / (W - w))) : 0.5;
    var Y = H > h ? Math.min(1, Math.max(0, (f[1] * H - ty * h) / (H - h))) : 0.5;
    img.style.objectPosition = (X * 100).toFixed(2) + '% ' + (Y * 100).toFixed(2) + '%';
    /* zoom towards the face */
    var ox = f[0] * W - X * (W - w), oy = f[1] * H - Y * (H - h);
    img.style.transformOrigin = Math.round(ox) + 'px ' + Math.round(oy) + 'px';
  }
  function focusAll(root) { (root || document).querySelectorAll('[data-cg-focus]').forEach(focusImg); }
  var focusUntil = 0;
  function focusLoop() {
    focusAll();
    if (performance.now() < focusUntil) requestAnimationFrame(focusLoop);
  }
  function kickFocus() { var run = performance.now() > focusUntil; focusUntil = performance.now() + 900; if (run) requestAnimationFrame(focusLoop); }
  document.addEventListener('pointerover', function (e) { if (e.target.closest && e.target.closest('.cg-panels__row')) kickFocus(); });
  document.addEventListener('focusin', function (e) { if (e.target.closest && e.target.closest('.cg-panels__row')) kickFocus(); });
  document.addEventListener('load', function (e) { if (e.target.tagName === 'IMG' && e.target.closest('[data-cg-focus]')) focusImg(e.target.closest('[data-cg-focus]')); }, true);
  window.addEventListener('resize', function () { focusAll(); });
  window.addEventListener('load', function () { focusAll(); });
  document.addEventListener('shopify:section:load', function (e) { focusAll(e.target); });
  document.addEventListener('shopify:block:select', function () { kickFocus(); });
  if (document.readyState !== 'loading') focusAll(); else document.addEventListener('DOMContentLoaded', function () { focusAll(); });

  document.addEventListener('shopify:block:select', function (e) {
    var key = e.target.getAttribute && e.target.getAttribute('data-cg-key');
    var group = e.target.closest && e.target.closest('[data-cg-group]');
    if (key && group) activate(group, key);
  });
})();
